/* eslint class-methods-use-this: ["error", { "exceptMethods": ["onclick","unbind"] }] */

/**
 * Created by christophe.gaon on 30/01/2017.
 * Tag plugin to manage event on google datalayer
 */
class TagPlugin {
  /**
   * constructor
   * @param el , dom elem on which add click event
   * @param binding params for tagging
   */
  constructor(el, binding) {
    this.valtechTag = binding.value;
    el.onclick = () => this.onclick();
  }

  /**
   * handler on click to deliver tag
   */
  onclick() {
    try {
      dataLayer.push(this.valtechTag);
    } catch {
      console.warn('datalayer is not defined');
    }
  }

  /**
   *
   * @param el
   */
  unbind(el) {
    el.onclick = undefined;
  }

  /**
   * Install the global plugin for handle key issue on sitecore editor
   * @param Vue
   */
  static install(Vue) {
    let tag;
    Vue.directive('tag', {
      bind: (el, binding) => {
        tag = new TagPlugin(el, binding);
      },
      unbind: (el) => tag.unbind(el),
    });
  }
}

export default {
  install: (Vue) => TagPlugin.install(Vue),
};
